import { useQuery } from "@tanstack/react-query";
import { getAvailableSections } from "../api/shortlist-report-api";
import type { SectionMeta } from "../api/shortlist-report-api";

export const useAvailableSections = () => {
	return useQuery<SectionMeta[]>({
		queryKey: ["shortlist-available-sections"],
		queryFn: getAvailableSections,
		staleTime: 10 * 60 * 1000,
	});
};
